import React, { useEffect, useState } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import '../CSS/PowerBI.css';

const PowerBI = () => {
    const [access_token, setAccessToken] = useState('');
    
    useEffect(() => {
        // Fetch reports data from your server
        fetch('/api/hello')
            .then((response) => response.json())
            .then((data) => {
                setAccessToken(data.accessToken);
            })
            .catch((error) => {
                console.error('Error fetching reports data:', error);
            });
    }, []);

    

    return (
        <div className="power-bi">
            <div className="reports-hero powerbi-hero">
  <div className="reports-hero-content">
    <p className="reports-eyebrow">Orion Financial Intelligence</p>

    <h1 className="stats-header">Activist Nonprofit Financial Filings</h1>

    <p className="reports-hero-description">
      This resource page offers insight into the nonprofit filing records of various
      animal rights activist organizations.
    </p>

    <ul className="reports-hero-list">
      <li>A detailed overview of prominent groups</li>
      <li>Annual financial data</li>
      <li>Individual fund-level breakdowns</li>
      <li>A searchable database with additional organizations&apos; information, as available</li>
      <li>Additional related nonprofit intelligence</li>
    </ul>

    <p className="reports-hero-description">
      <em>
        Please note that this resource is not exhaustive and is continuously updated as new data becomes available.
      </em>
    </p>
  </div>

</div>

            <style>
                {`
                    iframe {
                        border: none;
                    }
                `}
            </style>
          
        {access_token && (
            <PowerBIEmbed
                embedConfig={{
                    type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                    id: '5a991d2d-f4eb-4898-ade6-cc4c5487e641',
                    embedUrl: 'https://app.powerbi.com/reportEmbed?reportId=5a991d2d-f4eb-4898-ade6-cc4c5487e641&groupId=8462ee1f-e8db-4f03-bba9-021eabab566f&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLVVTLUVBU1QyLUItUFJJTUFSWS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
                    accessToken: access_token,
                    tokenType: models.TokenType.Aad, // Use models.TokenType.Aad for SaaS embed
                    //pageName : 'ReportSectionb9f969caf36ee4e18e90',
                    settings: {
                        panes: {
                            filters: {
                                expanded: false,
                                visible: false,
                            }
                        },
                        layoutType: models.LayoutType.Single,
                        navContentPaneEnabled: false, // This hides the entire page selector
                        background: models.BackgroundType.Transparent,
                        
                    }
                }}

                eventHandlers={
                    new Map([
                        ['loaded', function () { console.log('Report loaded'); }],
                        ['rendered', function () { console.log('Report rendered'); }],
                        ['error', function (event) { console.log(event.detail); }],
                        ['visualClicked', () => console.log('visual clicked')],
                        ['pageChanged', (event) => console.log(event)],
                    ])
                }

                cssClassName={"reportClass"}

                getEmbeddedComponent={(embeddedReport) => {
                    window.report = embeddedReport;
                }}
            />
            )}
        </div>
    );

}

export default PowerBI;